import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Element from 'element-ui';
import Request from '@/assets/js/request';
import Utils from '@/assets/js/utils';
import Player from '@/assets/js/player';
import Message from '@/assets/js/resetMessage';
import { installFrontLog } from '@/assets/js/frontLog';
import ls from 'local-storage'
import cafeOfd from 'cafe-ofd'
import 'cafe-ofd/package/index.css'
// import BaiduMap from 'vue-baidu-map';

// 先加载 element-ui 2.15 默认全量样式（含 el-descriptions 等新组件），再加载自定义主题覆盖
// 自定义主题基于 2.14 编译、不含新组件样式，加载顺序不可颠倒
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'
import "@/assets/iconfont/iconfont.css";

import '@/assets/js/filter';

Vue.config.productionTip = false

// 全局前端异常采集 (需求 7146951443), 必须在 new Vue 之前挂载才能接住启动阶段异常
installFrontLog(Vue)

Vue.use(Element);
Vue.use(cafeOfd);
// Vue.use(BaiduMap, {
//   ak: 'Y5qE51IMbh9Sdq2NAmMDUGGw'
// });

Vue.prototype.$request = Request;
Vue.prototype.$utils = Utils;
Vue.prototype.$player = Player;
Vue.prototype.$userType = new Map([
  [1, '乐迷'],
  [2, '艺人'],
  [3, '场地'],
  [4, '赞助商'],
  [5, '厂牌']
])
Vue.prototype.$message = Message;


//跳转秀发发行
const { VUE_APP_RELEASEWEB_URL } = process.env;

Vue.prototype.$release = async (uri) => {
  const redirect = encodeURIComponent(uri || '/');
  const res = await Request({
    url: '/user/login/releaseLogin',
    method: 'post',
  });
  const { state, result, msg } = res.data;
  if (state != 1) {
    return Message.error(msg)
  } else {
    window.open(`${VUE_APP_RELEASEWEB_URL}/autologin?sskey=${result || ''}&redirect=${redirect}`)
  }
}



new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
